import React, { useEffect, useState } from "react";
import { Table, Form, Button, Card, Row, Col, Pagination,Modal,Container } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { alertErrorMessage, alertSuccessMessage, confirmDelete } from "../../components/alert";


const ExamPapers = () => {
  const [programs, setPrograms] = useState([]);
  const [courseCategories, setCourseCategories] = useState([]);
  const [semesters, setSemesters] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [paperCodes, setPaperCodes] = useState([]);
  const [examMasters, setExamMasters] = useState([]);
  const [questionEntryTypes, setQuestionEntryTypes] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);



    const [active, setActive] = useState(false);

      const navigate = useNavigate();


const [editFormData, setEditFormData] = useState({
  id: "",
  title: "",
  code: "",
  exam_master_id: "",
  paper_code_id: "",
  question_entry_type: "",
  number_of_questions: "",
  marks_of_each: "",
  total_marks: "",
  program: "",
  course_category_id: "",
  semester_id: "",
  subject_id: ""
});





const [examMastersTable, setExamMastersTable] = useState([]);
const [examMastersModal, setExamMastersModal] = useState([]);
const [paperCodesModal, setPaperCodesModal] = useState([]);

  const [resetFlag, setResetFlag] = useState(false);
  const [showModal, setShowModal] = useState(false);


   const [loading, setLoading] = useState(false);



    const [formData, setFormData] = useState({
    title: "",
    code: "",
    exam_master_id: "",
    paper_code_id: "",
    question_entry_type: "",
    number_of_questions: "",
    marks_of_each: "",
    total_marks: "",
    id: ""
    });





 const fetchExamPaperById = async (id) => {
  const token = localStorage.getItem("token");
  // setLoading(true);
  try {
    const res = await axios.post(
      "https://codydealms.codydeasoftech.in/api/teacher/fetchExamPapers",
      {
        id,
        page: 1,
        perpage: 10,
        searchParam: {},
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (res.data.status && res.data.data) {
      const paper = res.data.data; // API returns a single object, not an array
     setEditFormData({
  id: paper.id || "",
  title: paper.title || "",
  code: paper.code || "",
  exam_master_id: paper.exam_master_id || "",
  program: paper.program || "",                      // ✅ matches Program select
  course_category_id: paper.program_category || "",  // ✅ matches Course Category select
  semester_id: paper.semester || "",                 // ✅ matches Semester select
  subject_id: paper.subject || "",                   // ✅ matches Subject select
  paper_code_id: paper.paper_code_id || "",          // ✅ matches Paper Code select
  question_entry_type: paper.question_entry_type || "",
  number_of_questions: paper.number_of_questions || "",
  marks_of_each: paper.marks_of_each || "",
  total_marks: paper.total_marks || ""
});
await fetchSubjects(paper.program_category);
await fetchPaperCodes(paper.subject, paper.semester);



      setShowEditModal(true); // ✅ Now will run
    }
  } catch (error) {
    console.error("Failed to fetch exam paper:", error);
  } finally {
    // setLoading(false);
  }
};



useEffect(() => {
  if (showModal || showEditModal) {
    const fetchQuestionEntryTypes = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(
          "https://codydealms.codydeasoftech.in/api/teacher/getPaperQuestionEntryType",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (res.data.status) {
          setQuestionEntryTypes(res.data.data);
        } else {
          setQuestionEntryTypes([]);
        }
      } catch (err) {
        console.error("Failed to fetch question entry types:", err);
      }
    };

    fetchQuestionEntryTypes();
  }
}, [showModal, showEditModal]);


  const [searchFilter, setSearchFilter] = useState({
      search_key: "",
    program: "",
    courseCategory: "",
    semester: "",
    subject: "",
    paperCode: "",
  });

  const [pagination, setPagination] = useState({
    page: 1,
    perpage: 10,
    last_page: 1,
  });

  // === API Calls for dropdowns ===
  const fetchPrograms = async () => {
    const token = localStorage.getItem("token");
    const res = await axios.get(
      "https://codydealms.codydeasoftech.in/api/teacher/programs",
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (res.data.status) setPrograms(res.data.data.programs);
  };

  const fetchCourseCategories = async () => {
    const token = localStorage.getItem("token");
    const res = await axios.get(
      "https://codydealms.codydeasoftech.in/api/teacher/courseCategories",
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (res.data.status) setCourseCategories(res.data.data.courseCategories);
  };

  const fetchSemesters = async () => {
    const token = localStorage.getItem("token");
    const res = await axios.get(
      "https://codydealms.codydeasoftech.in/api/teacher/semesters",
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (res.data.status) setSemesters(res.data.data.semesters);
  };

  const fetchSubjects = async (courseCategoryId) => {
    const token = localStorage.getItem("token");
    const res = await axios.post(
      "https://codydealms.codydeasoftech.in/api/teacher/subjects",
      { course_category: courseCategoryId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (res.data.status) setSubjects(res.data.data);
  };

  const fetchPaperCodes = async (subjectId, semesterId) => {
    const token = localStorage.getItem("token");
    const res = await axios.post(
      "https://codydealms.codydeasoftech.in/api/teacher/paperCodes",
      { subject: subjectId, semester: semesterId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (res.data.status) setPaperCodes(res.data.data);
    else setPaperCodes([]);
  };

  // === Main Data Fetch ===
  const fetchExamPapers = async (page = 1) => {
  setLoading(true); // start loader
  const token = localStorage.getItem("token");

  try {
    const res = await axios.post(
      "https://codydealms.codydeasoftech.in/api/teacher/fetchExamPapers",
      {
        page,
        perpage: pagination.perpage,
        searchParam: {
          search_key: searchFilter.search_key,
          program: searchFilter.program,
          course_category: searchFilter.courseCategory,
          subject: searchFilter.subject,
          semester: searchFilter.semester,
          paper_code: searchFilter.paperCode,
        },
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (res.data.status && res.data.data && res.data.data.exammasters) {
      const formatted = res.data.data.exammasters.map((exam) => ({
        ...exam,
        active: exam.active_stat === 1, // ensure boolean
      }));
      setExamMastersTable(formatted);
      setPagination(res.data.data.pagination);
    } else {
      setExamMastersTable([]); // no records
      setPagination({ page: 1, perpage: 10, last_page: 1 });
    }
  } catch (err) {
    console.error("Error fetching exam papers:", err);
    setExamMastersTable([]);
    setPagination({ page: 1, perpage: 10, last_page: 1 });
  } finally {
    setLoading(false); // stop loader
  }
};

  // === On Load ===
  useEffect(() => {
    fetchPrograms();
    fetchCourseCategories();
    fetchSemesters();
    fetchExamPapers(1);
  }, []);

  // === Dropdown Change Handlers ===
  const handleCourseCategoryChange = (e) => {
    const value = e.target.value;
    setSearchFilter({ ...searchFilter, courseCategory: value, subject: "" });
    fetchSubjects(value);
  };

  const handleSubjectOrSemesterChange = (name, value) => {
    const updated = { ...searchFilter, [name]: value };
    setSearchFilter(updated);

    if (name === "subject" || name === "semester") {
      if (updated.subject && updated.semester) {
        fetchPaperCodes(updated.subject, updated.semester);
      }
    }
  };

  const fetchExamMasters = async () => {
  const token = localStorage.getItem("token");
  try {
    const res = await axios.post(
      "https://codydealms.codydeasoftech.in/api/teacher/fetchExamMaster",
      {
        page: 1,
        perpage: 10,
        searchParam: {
          search_key: "",
          program: "",
          course_category: "",
          subject: "",
          semester: "",
        },
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (res.data.status) {
      setExamMastersModal(res.data.data.exammasters);
    }
  } catch (error) {
    console.error("Failed to fetch exam masters:", error);
  }
};


useEffect(() => {
  if (showModal || showEditModal) {
    fetchExamMasters();
  }
}, [showModal, showEditModal]);










const handleSubmit = async (e) => {
  e.preventDefault();
  const token = localStorage.getItem("token");

  try {
    const res = await axios.post(
      "https://codydealms.codydeasoftech.in/api/teacher/addEditExamPaper",
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (res.data.status) {
      // Swal.fire({
      //   icon: "success",
      //   title: res.data.message,
      //   timer: 2000,
      //   showConfirmButton: false
      // });

      alertSuccessMessage(res.data.message)


      setFormData({
        title: "",
        code: "",
        exam_master_id: "",
        paper_code_id: "",
        question_entry_type: "",
        number_of_questions: "",
        marks_of_each: "",
        total_marks: "",
        id: ""
      });
      setShowModal(false);
      fetchExamPapers(1);
    } else {
      alertErrorMessage(res.data.message)

    }
  } catch (error) {
    // Swal.fire({
    //   icon: "error",
    //   title: "Error",
    //   text: error.message || "Something went wrong",
    // });
    alertErrorMessage(error.data.message)


  }
};


const handleEdit = async (e) => {
  e.preventDefault();
  console.log("📝 handleEdit called with form data:", editFormData);

  const token = localStorage.getItem("token");
  if (!token) {
    console.error("❌ No token found in localStorage!");
    return;
  }

  // Prepare payload
  const payload = {
    id: editFormData.id, // ID of the paper to edit
    title: editFormData.title,
    code: editFormData.code,
    exam_master_id: editFormData.exam_master_id,
    paper_code_id: editFormData.paper_code_id,
    question_entry_type: editFormData.question_entry_type,
    number_of_questions: editFormData.number_of_questions,
    marks_of_each: editFormData.marks_of_each,
    total_marks: editFormData.total_marks,
  };

  console.log("📦 Payload to send:", payload);

  try {
    const res = await axios.post(
      "https://codydealms.codydeasoftech.in/api/teacher/addEditExamPaper",
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    console.log("✅ API Response:", res.data);

    if (res.data.status) {
      // Swal.fire({
      //   icon: "success",
      //   title: res.data.message,
      //   timer: 2000,
      //   showConfirmButton: false,
      // });

      alertSuccessMessage(res.data.message)

      // Reset form
      setEditFormData({
        id: "",
        title: "",
        code: "",
        exam_master_id: "",
        paper_code_id: "",
        question_entry_type: "",
        number_of_questions: "",
        marks_of_each: "",
        total_marks: "",
        program: "",
        course_category_id: "",
        semester_id: "",
        subject_id: "",
      });

      setShowEditModal(false);
      fetchExamPapers(1); // Refresh table
    } else {
      // Swal.fire({
      //   icon: "error",
      //   title: "Error",
      //   text: res.data.message || "Something went wrong",
      // });

      alertErrorMessage(res.data.message)
    }
  } catch (err) {
    console.error("❌ API call failed:", err.response?.data || err.message);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: err.response?.data?.message || err.message || "Something went wrong",
    });
  }
};

const resetFilter = () => {
  setSearchFilter({
    search_key: "",
    program: "",
    courseCategory: "",
    semester: "",
    subject: "",
    paperCode: "",
  });
  setSubjects([]);
  setPaperCodes([]);
  setResetFlag(true); // tells useEffect to run after state update
};

useEffect(() => {
  if (resetFlag) {
    fetchExamPapers(1);
    setResetFlag(false);
  }
}, [resetFlag]);

const handleToggleActive = async (id, currentStatus) => {
  const newStatus = currentStatus === 1 ? 0 : 1;

  setExamMastersTable(prev =>
    prev.map(exam =>
      exam.id === id ? { ...exam, active_stat: newStatus } : exam
    )
  );

  const result = await Swal.fire({
    title: "Are you sure?",
    text: newStatus === 1
      ? "You want to activate this exam?"
      : "You want to deactivate this exam?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: newStatus === 1 ? "Yes, activate" : "Yes, deactivate",
    cancelButtonText: "Cancel",
  });

  if (!result.isConfirmed) {
    // If cancelled, revert back in UI
    setExamMastersTable(prev =>
      prev.map(exam =>
        exam.id === id ? { ...exam, active_stat: currentStatus } : exam
      )
    );
    return;
  }

  // ✅ If confirmed, call API
  try {
    const token = localStorage.getItem("token");
    const res = await axios.post(
      "https://codydealms.codydeasoftech.in/api/teacher/changeStatusExamPaper",
      { id, current_active_stat: currentStatus },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (res.data?.status) {
      // Swal.fire({
      //   icon: "success",
      //   title: res.data.message || "Status updated",
      //   timer: 1500,
      //   showConfirmButton: false,
      // });

      alertSuccessMessage(res.data.message)
    }
  } catch (err) {
    // If API fails → revert UI
    setExamMastersTable(prev =>
      prev.map(exam =>
        exam.id === id ? { ...exam, active_stat: currentStatus } : exam
      )
    );

    // Swal.fire({
    //   icon: "error",
    //   title: "Failed to update status",
    //   text: err.response?.data?.message || "Something went wrong",
    // });

    alertErrorMessage(err.response.data.message)
  }
};


const handleDelete = async (id) => {
  Swal.fire({
    title: "Are you sure?",
    text: "This action cannot be undone!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.post(
          "https://codydealms.codydeasoftech.in/api/teacher/deleteExamPaper",
          { id },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // // ✅ Use API response message here
        // Swal.fire({
        //   icon: res.data.status ? "success" : "error",
        //   title: res.data.message || "Operation completed",
        //   showConfirmButton: false,
        //   timer: 2000,
        //   position: "center",
        // });
        alertSuccessMessage(res.data.message)

        // ✅ Refresh table if delete success
        if (res.data.status) {
          fetchExamPapers();
        }
      } catch (error) {
        console.error("Error deleting:", error);

        // ✅ Show API error or fallback message
        // Swal.fire({
        //   icon: "error",
        //   title:
        //     error.response?.data?.message || "Failed to delete. Try again!",
        //   showConfirmButton: false,
        //   timer: 2000,
        //   position: "center",
        // });
        alertErrorMessage(error.response?.data?.message)
      }
    }
  });
};


  const handleAddQuestions = (examId) => {
    navigate(`/add-questions/${examId}`);
  };



if (loading) return (
  <div className="d-flex justify-content-center align-items-center vh-100">
    <div className="text-center">
      <div className="spinner-border text-primary" role="status" style={{ width: '2rem', height: '2rem' }}>
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
); 
  return (
    <Container className="container mt-3" style={{maxWidth: "1462px"}}>

            <h4 className="my-4 fw-bold">Exam Papers</h4>

      {/* Search Card */}
      <Card className="mb-4 p-3">
        <h4 className="fw-bold">Search Exam Paper List</h4>
        <Row className="gy-3">

            <Col md={3}>
  <Form.Label>Search by Code/Title</Form.Label>
  <Form.Control
    type="text"
    placeholder="Enter code"
    value={searchFilter.search_key}
    onChange={(e) =>
      setSearchFilter({ ...searchFilter, search_key: e.target.value })
    }
  />
</Col>

          <Col md={3}>
            <Form.Label>Program</Form.Label>
            <Form.Select
              value={searchFilter.program}
              onChange={(e) =>
                setSearchFilter({ ...searchFilter, program: e.target.value })
              }
            >
              <option value="">Select Program</option>
              {programs.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.program_master_code}
                </option>
              ))}
            </Form.Select>
          </Col>

          <Col md={3}>
            <Form.Label>Course Category</Form.Label>
            <Form.Select
              value={searchFilter.courseCategory}
              onChange={handleCourseCategoryChange}
            >
              <option value="">Select Course Category</option>
              {courseCategories.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {cat.name}
                </option>
              ))}
            </Form.Select>
          </Col>

          <Col md={3}>
            <Form.Label>Semester</Form.Label>
            <Form.Select
              value={searchFilter.semester}
              onChange={(e) =>
                handleSubjectOrSemesterChange("semester", e.target.value)
              }
            >
              <option value="">Select Semester</option>
              {semesters.map((sem) => (
                <option key={sem.id} value={sem.id}>
                  {sem.full_name}
                </option>
              ))}
            </Form.Select>
          </Col>

          <Col md={3}>
            <Form.Label>Subject</Form.Label>
            <Form.Select
              value={searchFilter.subject}
              onChange={(e) =>
                handleSubjectOrSemesterChange("subject", e.target.value)
              }
            >
              <option value="">Select Subject</option>
              {subjects.map((sub) => (
                <option key={sub.id} value={sub.id}>
                  {sub.name}
                </option>
              ))}
            </Form.Select>
          </Col>

          <Col md={3}>
            <Form.Label>Paper Code</Form.Label>
            <Form.Select
              value={searchFilter.paperCode}
              onChange={(e) =>
                setSearchFilter({ ...searchFilter, paperCode: e.target.value })
              }
            >
              <option value="">Select Paper Code</option>
              {paperCodes.map((pc) => (
                <option key={pc.id} value={pc.id}>
                  {pc.paper_code}
                </option>
              ))}
            </Form.Select>
          </Col>

          <Col md={2} className="d-flex align-items-end">
            <Button onClick={() => fetchExamPapers(1)} variant="primary" className="btn btn-primary w-100 w-md-auto">
               <i class="fa-solid fa-magnifying-glass"></i> Search

            </Button>

          </Col>

          <Col md={2} className="d-flex align-items-end">
            <Button onClick={resetFilter} variant="secondary" className="btn btn-primary w-100 w-md-auto">
             <i class="fa-solid fa-rotate-left"></i>  Reset
            </Button>
          </Col>
        </Row>
      </Card>

      <Button variant="success" className="text-white fw-bold px-4" onClick={() => setShowModal(true)}>
        Add Paper  <i className="fa-solid fa-plus ms-2"></i>
      </Button>


      {/* Table */}
<table className="table table-striped table-hover table-responsive mt-4">
  <thead className="table-primary">
    <tr>
      <th>ID</th>
      <th>Title</th>
      <th>Exam Name</th>
      <th>Code</th>
      <th>Subject</th>
      <th>Paper Code</th>
      <th>Type</th>
      <th className="text-center">Status</th>
      <th className="text-center">Action</th>
      <th className="text-center">Questions</th>
    </tr>
  </thead>
  <tbody>
    {examMastersTable.length > 0 ? (
      examMastersTable.map((exam, index) => (
        <tr key={exam.id}>
          <td>{index + 1}.</td>
          <td>{exam.title}</td>
          <td>{exam.exam_master_name}</td>
          <td>{exam.code}</td>
          <td>
            <div>
              {exam.program_master_code} <br />
              {exam.program_category_name} <br />
              {exam.subject_name} <br />
              {exam.semester_name}
            </div>
          </td>
          <td>{exam.paper_code}</td>
          <td>{exam.exam_paper_type_name}</td>

          <td className="text-center">
            <Form>
              <Form.Check
                type="switch"
                id={`switch-${exam.id}`}
                checked={exam.active_stat === 1}
                onChange={() => handleToggleActive(exam.id, exam.active_stat)}
              />
            </Form>
          </td>

          <td className="text-center">
            <Button
              size="sm"
              variant="primary"
              className="me-2"
              onClick={() => fetchExamPaperById(exam.id)}
            >
              <i className="fa-solid fa-pencil"></i>
            </Button>
            <Button
              size="sm"
              className="btn btn-danger text-white"
              onClick={() => handleDelete(exam.id)}
            >
              <i className="fa-solid fa-trash"></i>
            </Button>
          </td>
          <td className="text-center">
            <Button
              size="sm"
              variant="warning"
              className="btn text-black"
              onClick={() => handleAddQuestions(exam.id)}
            >
              View
            </Button>
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="10" className="text-center">
          No records found
        </td>
      </tr>
    )}
  </tbody>
</table>





       {/* Edit modal */}

  <Modal
  show={showEditModal}
  onHide={() => setShowEditModal(false)}
  centered
  size="lg"
  backdrop="static"
  keyboard={false}
>
  <Modal.Header closeButton   style={{backgroundColor: "#5856d6",color: '#fff'}}>
    <Modal.Title>Edit Exam Paper</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Program <span className="text-danger">*</span></Form.Label>
            <Form.Select
              value={editFormData.program || ""}
              onChange={(e) =>
                setEditFormData({ ...editFormData, program: e.target.value })
              }
            >
              <option value="">Select Program</option>
              {programs.map((prog) => (
                <option key={prog.id} value={prog.id}>
                  {prog.program_master_code}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Course Category <span className="text-danger">*</span></Form.Label>
            <Form.Select
              value={editFormData.course_category_id || ""}
              onChange={(e) => {
                const val = e.target.value;
                setEditFormData({
                  ...editFormData,
                  course_category_id: val,
                  subject_id: "",
                  paper_code_id: "",
                });
                fetchSubjects(val);
              }}
            >
              <option value="">Select Course Category</option>
              {courseCategories.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {cat.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Semester <span className="text-danger">*</span></Form.Label>
            <Form.Select
              value={editFormData.semester_id || ""}
              onChange={(e) => {
                const val = e.target.value;
                setEditFormData({
                  ...editFormData,
                  semester_id: val,
                  paper_code_id: "",
                });
                if (editFormData.subject_id) {
                  fetchPaperCodes(editFormData.subject_id, val);
                }
              }}
            >
              <option value="">Select Semester</option>
              {semesters.map((sem) => (
                <option key={sem.id} value={sem.id}>
                  {sem.full_name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Subject <span className="text-danger">*</span></Form.Label>
            <Form.Select
              value={editFormData.subject_id || ""}
              onChange={(e) => {
                const val = e.target.value;
                setEditFormData({
                  ...editFormData,
                  subject_id: val,
                  paper_code_id: "",
                });
                if (editFormData.semester_id) {
                  fetchPaperCodes(val, editFormData.semester_id);
                }
              }}
              disabled={!editFormData.course_category_id}
            >
              <option value="">Select Subject</option>
              {subjects.map((subj) => (
                <option key={subj.id} value={subj.id}>
                  {subj.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Title <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter exam title"
              value={editFormData.title}
              onChange={(e) =>
                setEditFormData({ ...editFormData, title: e.target.value })
              }
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Code <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter exam code"
              value={editFormData.code}
              onChange={(e) =>
                setEditFormData({ ...editFormData, code: e.target.value })
              }
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Paper Code <span className="text-danger">*</span></Form.Label>
            <Form.Select
              value={editFormData.paper_code_id || ""}
              onChange={(e) =>
                setEditFormData({
                  ...editFormData,
                  paper_code_id: e.target.value,
                })
              }
              disabled={!editFormData.subject_id || !editFormData.semester_id}
            >
              <option value="">Select Paper Code</option>
              {paperCodes.map((pc) => (
                <option key={pc.id} value={pc.id}>
                  {pc.paper_code}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Select Exam <span className="text-danger">*</span></Form.Label>
            <Form.Select
              value={editFormData.exam_master_id || ""}
              onChange={(e) =>
                setEditFormData({
                  ...editFormData,
                  exam_master_id: e.target.value,
                })
              }
            >
              <option value="">Select Exam</option>
              {examMastersModal.map((exam) => (
                <option key={exam.id} value={exam.id}>
                  {exam.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Question Entry Type <span className="text-danger">*</span></Form.Label>
            <Form.Select
              value={Number(editFormData.question_entry_type) || ""}
              onChange={(e) =>
                setEditFormData({
                  ...editFormData,
                  question_entry_type: e.target.value,
                })
              }
            >
              <option value="">Select Question Entry Type</option>
              {questionEntryTypes.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Number of Questions <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="number"
              min={0}
              placeholder="Enter number of questions"
              value={editFormData.number_of_questions}
              onChange={(e) => {
                const number_of_questions = e.target.value;
                const marks_of_each = editFormData.marks_of_each;
                setEditFormData({
                  ...editFormData,
                  number_of_questions,
                  total_marks:
                    number_of_questions && marks_of_each
                      ? Number(number_of_questions) * Number(marks_of_each)
                      : "",
                });
              }}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Marks of Each <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="number"
              min={0}
              placeholder="Enter marks of each"
              value={editFormData.marks_of_each}
              onChange={(e) => {
                const marks_of_each = e.target.value;
                const number_of_questions = editFormData.number_of_questions;
                setEditFormData({
                  ...editFormData,
                  marks_of_each,
                  total_marks:
                    number_of_questions && marks_of_each
                      ? Number(number_of_questions) * Number(marks_of_each)
                      : "",
                });
              }}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Total Marks <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="number"
              value={editFormData.total_marks}
              readOnly
            />
          </Form.Group>
        </Col>
      </Row>
    </Form>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowEditModal(false)}>
      Close
    </Button>
    <Button variant="primary" onClick={(handleEdit)}>
      Update
    </Button>
  </Modal.Footer>
</Modal>

      {/* Pagination */}

      {pagination?.last_page > 1 && (
  <Pagination>
    <Pagination.Prev
      disabled={pagination.page === 1}
      onClick={() => fetchExamPapers(pagination.page - 1)}
    />
    {[...Array(pagination.last_page)].map((_, idx) => (
      <Pagination.Item
        key={idx + 1}
        active={pagination.page === idx + 1}
        onClick={() => fetchExamPapers(idx + 1)}
      >
        {idx + 1}
      </Pagination.Item>
    ))}
    <Pagination.Next
      disabled={pagination.page === pagination.last_page}
      onClick={() => fetchExamPapers(pagination.page + 1)}
    />
  </Pagination>
)}

      {/* <Pagination>
        {[...Array(pagination.last_page)].map((_, idx) => (
          <Pagination.Item
            key={idx + 1}
            active={pagination.page === idx + 1}
            onClick={() => fetchExamPapers(idx + 1)}
          >
            {idx + 1}
          </Pagination.Item>
        ))}
      </Pagination> */}

      {/* add paper modal */}


      <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg" backdrop="static" keyboard={false}>
  <Modal.Header closeButton  style={{backgroundColor: "#5856d6",color: '#fff'}}>
    <Modal.Title>Add Exam Paper</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Program <span className="text-danger">*</span></Form.Label>
            <Form.Select
              value={formData.program || ""}
              onChange={(e) =>
                setFormData({ ...formData, program: e.target.value })
              }
            >
              <option value="">Select Program</option>
              {programs.map((prog) => (
                <option key={prog.id} value={prog.id}>
                  {prog.program_master_code}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Course Category <span className="text-danger">*</span></Form.Label>
            <Form.Select
              value={formData.course_category_id || ""}
              onChange={(e) => {
                const val = e.target.value;
                setFormData({
                  ...formData,
                  course_category_id: val,
                  subject_id: "",
                  paper_code_id: "",
                });
                fetchSubjects(val); // fetch subjects for new category
              }}
            >
              <option value="">Select Course Category</option>
              {courseCategories.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {cat.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Semester <span className="text-danger">*</span></Form.Label>
            <Form.Select
              value={formData.semester_id || ""}
              onChange={(e) => {
                const val = e.target.value;
                setFormData({
                  ...formData,
                  semester_id: val,
                  paper_code_id: "",
                });
                // Try fetching paper codes if subject is already selected
                if (formData.subject_id) {
                  fetchPaperCodes(formData.subject_id, val);
                }
              }}
            >
              <option value="">Select Semester</option>
              {semesters.map((sem) => (
                <option key={sem.id} value={sem.id}>
                  {sem.full_name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Subject <span className="text-danger">*</span></Form.Label>
            <Form.Select
              value={formData.subject_id || ""}
              onChange={(e) => {
                const val = e.target.value;
                setFormData({
                  ...formData,
                  subject_id: val,
                  paper_code_id: "",
                });
                // Fetch paper codes if semester is already selected
                if (formData.semester_id) {
                  fetchPaperCodes(val, formData.semester_id);
                }
              }}
              disabled={!formData.course_category_id}
            >
              <option value="">Select Subject</option>
              {subjects.map((subj) => (
                <option key={subj.id} value={subj.id}>
                  {subj.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Row>
  <Col md={6}>
    <Form.Group className="mb-3">
      <Form.Label className="fw-bold">Title <span className="text-danger">*</span></Form.Label>
      <Form.Control
        type="text"
        placeholder="Enter exam title"
        value={formData.title}
        onChange={(e) => setFormData({ ...formData, title: e.target.value })}
      />
    </Form.Group>
  </Col>
  <Col md={6}>
    <Form.Group className="mb-3">
      <Form.Label className="fw-bold">Code <span className="text-danger">*</span></Form.Label>
      <Form.Control
        type="text"
        placeholder="Enter exam code"
        value={formData.code}
        onChange={(e) => setFormData({ ...formData, code: e.target.value })}
      />
    </Form.Group>
  </Col>
</Row>

      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Paper Code <span className="text-danger">*</span></Form.Label>
            <Form.Select
              value={formData.paper_code_id || ""}
              onChange={(e) =>
                setFormData({ ...formData, paper_code_id: e.target.value })
              }
              disabled={!formData.subject_id || !formData.semester_id}
            >
              <option value="">Select Paper Code</option>
              {paperCodes.map((pc) => (
                <option key={pc.id} value={pc.id}>
                  {pc.paper_code}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Select Exam <span className="text-danger">*</span></Form.Label>
            <Form.Select
              value={formData.exam_master_id || ""}
              onChange={(e) =>
                setFormData({ ...formData, exam_master_id: e.target.value })
              }
            >
              <option value="">Select Exam</option>
              {examMastersModal.map((exam) => (
                <option key={exam.id} value={exam.id}>
                  {exam.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Row>
  <Col md={6}>
    <Form.Group className="mb-3">
      <Form.Label className="fw-bold">Question Entry Type <span className="text-danger">*</span></Form.Label>
      {/* <Form.Select
        value={formData.question_entry_type || ""}
        onChange={(e) =>
          setFormData({ ...formData, question_entry_type: e.target.value })
        }
      >
        <option value="">Select Question Entry Type</option>
        {questionEntryTypes.map((type) => (
          <option key={type.id} value={type.id}>
            {type.name}
          </option>
        ))}
      </Form.Select> */}
      <Form.Select
  value={formData.question_entry_type || ""}
  onChange={(e) => {
    const val = e.target.value;
    setFormData((prev) => ({
      ...prev,
      question_entry_type: val,
      // Auto set number_of_questions to 1 if single question entry
      number_of_questions:
        questionEntryTypes.find((type) => type.id == val)?.name ===
        "Single Question Entry"
          ? 1
          : prev.number_of_questions,
      // Recalculate total_marks
      total_marks:
        questionEntryTypes.find((type) => type.id == val)?.name ===
        "Single Question Entry"
          ? 1 * Number(prev.marks_of_each || 0)
          : prev.number_of_questions * Number(prev.marks_of_each || 0),
    }));
  }}
>
  <option value="">Select Question Entry Type</option>
  {questionEntryTypes.map((type) => (
    <option key={type.id} value={type.id}>
      {type.name}
    </option>
  ))}
</Form.Select>

    </Form.Group>
  </Col>
  <Col md={6}>
    <Form.Group className="mb-3">
      <Form.Label className="fw-bold">Number of Questions <span className="text-danger">*</span></Form.Label>
      {/* <Form.Control
        type="number"
        min={0}
        placeholder="Enter number of questions"
        value={formData.number_of_questions}
        onChange={(e) => {
          const number_of_questions = e.target.value;
          const marks_of_each = formData.marks_of_each;
          setFormData({
            ...formData,
            number_of_questions,
            total_marks:
              number_of_questions && marks_of_each
                ? Number(number_of_questions) * Number(marks_of_each)
                : "",
          });
        }}
      /> */}
      <Form.Control
  type="number"
  min={0}
  placeholder="Enter number of questions"
  value={formData.number_of_questions}
  onChange={(e) => {
    const number_of_questions = e.target.value;
    const marks_of_each = formData.marks_of_each;
    setFormData({
      ...formData,
      number_of_questions,
      total_marks:
        number_of_questions && marks_of_each
          ? Number(number_of_questions) * Number(marks_of_each)
          : "",
    });
  }}
  readOnly={
    questionEntryTypes.find(
      (type) => type.id == formData.question_entry_type
    )?.name === "Single Question Entry"
  }
/>

    </Form.Group>
  </Col>
</Row>
<Row>
  <Col md={6}>
    <Form.Group className="mb-3">
      <Form.Label className="fw-bold">Marks of Each <span className="text-danger">*</span></Form.Label>
      <Form.Control
        type="number"
        min={0}
        placeholder="Enter marks of each"
        value={formData.marks_of_each}
        onChange={(e) => {
          const marks_of_each = e.target.value;
          const number_of_questions = formData.number_of_questions;
          setFormData({
            ...formData,
            marks_of_each,
            total_marks:
              number_of_questions && marks_of_each
                ? Number(number_of_questions) * Number(marks_of_each)
                : "",
          });
        }}
      />
    </Form.Group>
  </Col>
  <Col md={6}>
    <Form.Group className="mb-3">
      <Form.Label className="fw-bold">Total Marks <span className="text-danger">*</span></Form.Label>
      <Form.Control
        type="number"
        value={formData.total_marks}
        readOnly
      />
    </Form.Group>
  </Col>
</Row>

    </Form>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowModal(false)}>
      Close
    </Button>
    <Button variant="primary" onClick={handleSubmit}>
      Submit
    </Button>
  </Modal.Footer>
</Modal>








    </Container>
  );
};

export default ExamPapers;
